import { cx } from "@emotion/css";
import { FunctionComponent } from "react";

import { useTheme } from "../../hooks/useTheme";

import { createStarsRatingStyles } from "./helpers/createStarsRatingStyles";
import { ReactComponent as Star } from "./icons/star.svg";

type StarsRatingProps = {
  value: number;
  size: number;
  className?: string;
};

export const StarsRating: FunctionComponent<StarsRatingProps> = ({
  value,
  size,
  className,
}) => {
  const classes = createStarsRatingStyles(useTheme());
  return (
    <div className={cx(classes.root, className)}>
      {[...Array(5).keys()].map((starIndex) => (
        <Star
          width={size}
          height={size}
          className={starIndex + 1 <= value ? classes.active : classes.inactive}
          key={starIndex}
        />
      ))}
    </div>
  );
};
